import { MinMaxArray } from 'shared'

export type sortFields =
  | 'card.cn'
  | 'card.name'
  | 'card.rarity'
  | 'card.expansionReleaseDate'
  | 'price'
  | 'customComputedField'
  | 'locationName'
  | 'listedAt'
export type sortTypes = 'string' | 'number' | '% diff' | 'date'
export type sortKeys =
  | 'name'
  | 'collectorNo'
  | 'rarity'
  | 'expansionReleaseDate'
  | 'price'
  | 'percentDiff'
  | 'locationName'
  | 'listedAt'

export interface Sort {
  by: sortFields
  direction: 'asc' | 'desc' | undefined
  type: sortTypes
}

export const sortOptions: {
  title: string
  field: sortFields
  type: sortTypes
  key: sortKeys
  direction: 'asc' | 'desc'
}[] = [
  {
    title: 'card.name',
    field: 'card.name',
    type: 'string',
    key: 'name',
    direction: 'asc',
  },
  {
    title: 'card.name',
    field: 'card.name',
    type: 'string',
    key: 'name',
    direction: 'desc',
  },
  {
    title: 'card.collectorNo',
    field: 'card.cn',
    type: 'number',
    key: 'collectorNo',
    direction: 'asc',
  },
  {
    title: 'card.collectorNo',
    field: 'card.cn',
    type: 'number',
    key: 'collectorNo',
    direction: 'desc',
  },
  {
    title: 'card.rarity',
    field: 'card.rarity',
    type: 'number',
    key: 'rarity',
    direction: 'asc',
  },
  {
    title: 'card.rarity',
    field: 'card.rarity',
    type: 'number',
    key: 'rarity',
    direction: 'desc',
  },
  {
    title: 'card.expansionReleaseDate',
    field: 'card.expansionReleaseDate',
    type: 'string',
    key: 'expansionReleaseDate',
    direction: 'asc',
  },
  {
    title: 'card.expansionReleaseDate',
    field: 'card.expansionReleaseDate',
    type: 'string',
    key: 'expansionReleaseDate',
    direction: 'desc',
  },
  {
    title: 'card.price',
    field: 'price',
    type: 'number',
    key: 'price',
    direction: 'asc',
  },
  {
    title: 'card.price',
    field: 'price',
    type: 'number',
    key: 'price',
    direction: 'desc',
  },
  {
    title: 'stockPricing.percentDiff',
    field: 'customComputedField',
    type: '% diff',
    key: 'percentDiff',
    direction: 'asc',
  },
  {
    title: 'stockPricing.percentDiff',
    field: 'customComputedField',
    type: '% diff',
    key: 'percentDiff',
    direction: 'desc',
  },
  {
    title: 'stockPricing.locationName',
    field: 'locationName',
    type: 'string',
    key: 'locationName',
    direction: 'asc',
  },
  {
    title: 'stockPricing.locationName',
    field: 'locationName',
    type: 'string',
    key: 'locationName',
    direction: 'desc',
  },
  {
    title: 'stockPricing.insertionOrder',
    field: 'listedAt',
    type: 'date',
    key: 'listedAt',
    direction: 'asc',
  },
  {
    title: 'stockPricing.insertionOrder',
    field: 'listedAt',
    type: 'date',
    key: 'listedAt',
    direction: 'desc',
  },
]

export const cardsSize: MinMaxArray = [1, 2, 3, 4, 5, 6, 7, 8, 9]
